import { Link } from 'react-router-dom';
import MangaCard from '@/components/base/MangaCard';
import { categories, sortedMangaByUpdate, featuredManga, mangaList } from '@/mocks/manga';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    'name': '韩国漫画网',
    'url': 'https://www.koreanmanhwa.cn/',
    'description': '韩国漫画网是热门漫画在线阅读平台，全网韩漫最快更新，涵盖韩漫大全，内容多样，加载快捷。',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': [
      {
        '@type': 'Question',
        'name': '韩国漫画网有哪些类型的漫画？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '韩国漫画网涵盖恋爱、动作、奇幻、悬疑、搞笑、恐怖、剧情、日常等多种类型的韩国漫画，满足不同读者的阅读需求。',
        },
      },
      {
        '@type': 'Question',
        'name': '韩国漫画网更新速度快吗？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '韩国漫画网以全网最快更新为目标，每日同步韩国最新漫画资源，确保读者第一时间获取最新韩漫内容。',
        },
      },
      {
        '@type': 'Question',
        'name': '如何在韩国漫画网阅读漫画？',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': '您可以直接在韩国漫画网浏览和阅读所有漫画内容，无需注册登录，打开即看，操作简单方便。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <section className="relative h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20art%20background%2C%20beautiful%20illustration%20with%20warm%20golden%20and%20coral%20tones%2C%20abstract%20geometric%20patterns%2C%20dreamy%20atmosphere%2C%20soft%20gradients%2C%20modern%20artistic%20composition%2C%20no%20text%2C%20clean%20minimal%20feel&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="韩国漫画在线阅读平台"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/60 via-foreground-900/40 to-foreground-900/60"></div>
        <div className="relative z-10 w-full text-center px-4 md:px-6">
          <h1 className="text-3xl md:text-5xl font-bold text-background-50 font-heading mb-4">
            全网韩漫 <strong className="text-accent-400">最快更新</strong>
          </h1>
          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            韩国漫画网汇集海量热门韩国漫画，涵盖恋爱、动作、奇幻、悬疑等多种类型，
            <br className="hidden md:block" />
            加载快捷，体验流畅，为您带来极致的韩漫在线阅读之旅
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/20 text-background-50 text-sm font-medium rounded-full hover:bg-background-50/30 backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer border border-background-50/30"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">漫画分类</h2>
            <p className="text-sm text-foreground-500 mt-1">探索你喜欢的漫画类型</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-background-100 transition-all cursor-pointer group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-500 transition-colors">
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors">{cat.name}</span>
              <span className="text-xs text-foreground-400">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100/70">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">热门推荐</h2>
              <p className="text-sm text-foreground-500 mt-1">读者评分最高的韩漫作品</p>
            </div>
            <Link to="/category/romance" className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap">
              查看更多 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
            {featuredManga.map((manga) => (
              <MangaCard
                key={manga.id}
                id={manga.id}
                title={manga.title}
                coverImage={manga.coverImage}
                category={manga.category}
                categorySlug={manga.categorySlug}
                rating={manga.rating}
                chapters={manga.chapters}
                updatedAt={manga.updatedAt}
                status={manga.status}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">最新更新</h2>
            <p className="text-sm text-foreground-500 mt-1">全网最快韩漫更新</p>
          </div>
          <Link to="/category/action" className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap">
            查看更多 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {sortedMangaByUpdate.slice(0, 10).map((manga) => (
            <MangaCard
              key={manga.id}
              id={manga.id}
              title={manga.title}
              coverImage={manga.coverImage}
              category={manga.category}
              categorySlug={manga.categorySlug}
              rating={manga.rating}
              chapters={manga.chapters}
              updatedAt={manga.updatedAt}
              status={manga.status}
            />
          ))}
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100/70">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">全部漫画</h2>
              <p className="text-sm text-foreground-500 mt-1">浏览所有韩漫作品</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {mangaList.map((manga) => (
              <MangaCard
                key={manga.id}
                id={manga.id}
                title={manga.title}
                coverImage={manga.coverImage}
                category={manga.category}
                categorySlug={manga.categorySlug}
                rating={manga.rating}
                chapters={manga.chapters}
                updatedAt={manga.updatedAt}
                status={manga.status}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 max-w-7xl mx-auto">
        <div className="bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-foreground-900/10"></div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
              加入韩漫爱好者社区
            </h2>
            <p className="text-background-100 text-sm md:text-base mb-6 max-w-lg mx-auto">
              每日更新最新韩国漫画，热门推荐不迷路，与千万读者一起畅享韩漫世界
            </p>
            <Link
              to="/about"
              className="inline-flex px-8 py-3 bg-background-50 text-primary-500 text-sm font-medium rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100/70">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading text-center mb-8">常见问题</h2>
          <div className="space-y-3">
            {[
              { q: '韩国漫画网有哪些类型的漫画？', a: '韩国漫画网涵盖恋爱、动作、奇幻、悬疑、搞笑、恐怖、剧情、日常等多种类型的韩国漫画，满足不同读者的阅读需求。无论是甜蜜的校园恋爱还是紧张刺激的动作冒险，这里都能找到你喜欢的作品。' },
              { q: '韩国漫画网更新速度快吗？', a: '韩国漫画网以全网最快更新为目标，每日同步韩国最新漫画资源，确保读者第一时间获取最新韩漫内容。我们的团队全天候监控韩国各大漫画平台，力争零时差为您呈现。' },
              { q: '如何在韩国漫画网阅读漫画？', a: '您可以直接在韩国漫画网浏览和阅读所有漫画内容，无需注册登录，打开即看，操作简单方便。网站采用先进的加载技术，确保阅读过程流畅无卡顿。' },
            ].map((faq, idx) => (
              <details key={idx} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-800 hover:text-primary-500 transition-colors">
                  {faq.q}
                  <span className="w-5 h-5 flex items-center justify-center transition-transform group-open:rotate-180">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}